<template>
  <div class="service-visit-page">
    <KTCard ref="preview" v-bind:title="'Add new'">
      <template v-slot:title>
        <h3 class="card-label">
          <router-link :to="{ name: 'list-service-visits' }">{{
            $t("MENU.ITEM.SERVICE.VISITS")
          }}</router-link>
          <i class="mr-2"></i>
          <small>{{ $t("LABELS.ADD_NEW") }}</small>
        </h3>
      </template>
      <template v-slot:toolbar>
        <div class="service-visit-page__actions">
          <BackButton />
          <SaveButton :isLoading="isLoadingServiceVisit" @save="onSave" />
        </div>
      </template>
      <template v-slot:body>
        <b-form>
          <ServiceVisitsForm ref="ServiceVisitsForm" :form="form" />
          <v-overlay :value="isLoadingServiceVisit">
            <v-progress-circular indeterminate size="64" />
          </v-overlay>
        </b-form>
      </template>
      <template v-slot:foot>
        <div v-show="_.size(errors) > 0" role="alert" class="alert alert-danger">
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error[0] }}
          </div>
        </div>
      </template>
      <template v-slot:toolbarfoot>
        <div class="service-visit-page__actions">
          <BackButton />
          <SaveButton :isLoading="isLoadingServiceVisit" @save="onSave" />
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SAVE_SERVICE_VISIT } from "@/modules/service-visits/store/service-visits.module";
import { mapGetters } from "vuex";
import KTCard from "@/view/content/Card.vue";
import SaveButton from "@/view/content/forms/components/SaveButton.vue";
import { serviceVisitFormPayload } from "../services/service-visit.mapper";
import ServiceVisitsForm from "../components/ServiceVisitsForm.vue";

export default {
  name: "ServiceVisitsAdd",
  components: {
    KTCard,
    SaveButton,
    ServiceVisitsForm
  },
  data() {
    return {
      errors: {},
      form: {
        machineId: this.routeNumber("machineId"),
        statusId: null,
        priorityId: null,
        isOnRoad: false,
        onRoadNote: null,
        serviceLocationId: null,
        dateFrom: null,
        dateTo: null,
        duration: null,
        serviceMileage: null,
        hoursWorked: null,
        workDone: null,
        mechanicIds: [],
        serviceTypeIds: this.routeNumber("serviceTypeId")
          ? [this.routeNumber("serviceTypeId")]
          : [],
        serviceTypeNotes: {},
        serviceTypeStatusIds: {},
        machineServiceSignalIds: this.routeNumber("machineServiceSignalId")
          ? [this.routeNumber("machineServiceSignalId")]
          : [],
        machineServiceSignalNotes: {},
        machineServiceSignalStatusIds: {},
        customTasks: []
      }
    };
  },
  computed: {
    ...mapGetters(["isLoadingServiceVisit"])
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.$i18n.t("MENU.ITEM.SERVICE.VISITS"),
        route: { name: "list-service-visits" }
      },
      { title: this.$i18n.t("LABELS.ADD_NEW") }
    ]);
  },
  methods: {
    routeNumber(name) {
      const value = this.$route.query[name];

      return value ? Number(value) : null;
    },
    onSave() {
      const formComponent = this.$refs.ServiceVisitsForm;
      formComponent.$v.form.$touch();
      if (formComponent.$v.form.$anyError) {
        this.$notify({
          group: "notify",
          type: "error",
          title: this.$t("ALERTS.ERROR"),
          text: "Please fill all required fields correctly"
        });
        return;
      }

      this.$store
        .dispatch(SAVE_SERVICE_VISIT, this.payload())
        .then(data => {
          this.errors = data.data.errors;
          this.$notify({
            group: "notify",
            type: "success",
            title: "<i class='flaticon2-checkmark'></i> Success",
            text: data.message
          });
          this.$router.push({ name: "list-service-visits" });
        })
        .catch(response => {
          this.errors = response.data.errors;
          this.$notify({
            group: "notify",
            type: "error",
            title: this.$t("ALERTS.ERROR"),
            text: response.data.message
          });
        });
    },
    payload() {
      return serviceVisitFormPayload(
        this.form,
        false,
        this.$refs.ServiceVisitsForm.defaultItemStatusId()
      );
    }
  }
};
</script>
